import {Button} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {WifiPoint} from '../../interfaces/WifiPoint';
import {MapLatLangCoordinates} from '../common/Map';
import ModalDraggable from '../common/ModalDraggable';
import WifiPointItemUpsert from './WifiPointItemUpsert';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  pk?: number;
  item?: WifiPoint;
  mode?: 'view' | 'update' | 'ack';
  bluetooth?: boolean;
  prefetch?: boolean;
  locationCoordinates?: MapLatLangCoordinates;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  onSubmitted?: () => void;
  onPurged?: () => void;
  onOpenHistory?: (type: 'wifi' | 'wifiLongTerm') => void;
  onOpen?: () => void;
  onClose?: Function;
}

const WifiPointItemUpsertButton = <T extends ComponentType = typeof Button>({
  pk,
  item,
  mode,
  bluetooth,
  prefetch,
  locationCoordinates,
  component,
  componentProps,
  children,
  onSubmitted,
  onPurged,
  onOpenHistory,
  onOpen,
  onClose,
}: Props<T>) => {
  const Component = component ?? Button;
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Component
        {...componentProps}
        onClick={() => {
          setIsOpened(true);
          onOpen?.();
        }}
      >
        {children}
      </Component>

      {isOpened ? (
        <ModalDraggable open={isOpened}>
          {({isActive}) => (
            <WifiPointItemUpsert
              pk={pk}
              item={item}
              mode={mode}
              bluetooth={bluetooth}
              prefetch={prefetch}
              locationCoordinates={locationCoordinates}
              isActiveModal={isActive}
              onClose={() => {
                setIsOpened(false);
                onClose?.();
              }}
              onSubmitted={() => {
                onSubmitted?.();
                if (!pk) {
                  setIsOpened(false);
                  onClose?.();
                }
              }}
              onPurged={onPurged}
              onOpenHistory={onOpenHistory}
            />
          )}
        </ModalDraggable>
      ) : null}
    </>
  );
};

export default WifiPointItemUpsertButton;
